import { composeIO } from 'react-compose-io'
import { titulosLiquidadosIO } from './TitulosLiquidados.IO'
import { TitulosLiquidadosView } from './TitulosLiquidados.View'

export const TitulosLiquidados = composeIO(TitulosLiquidadosView, titulosLiquidadosIO)
